import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const organizationSliceName = 'organization';

const getInitialState = () => ({
  organizationId: null as string | null,
});

export const organizationSlice = createSlice({
  name: organizationSliceName,
  initialState: getInitialState(),
  reducers: {
    setOrganizationId(state, { payload: organizationId }: PayloadAction<string | null>) {
      state.organizationId = organizationId;
    },
    reset(state) {
      Object.assign(state, getInitialState());
    },
  },
});

export type OrganizationSlicePayload = ReturnType<typeof organizationSlice.getInitialState>;
export default organizationSlice.reducer;
export const { reset } = organizationSlice.actions;
export const { setOrganizationId } = organizationSlice.actions;
